(ns dashboard.components.confirm-delete-attachment-modal
  (:require [dashboard.components.confirm-modal :refer [confirm-modal]]))

(defn modal-content [{:keys [filename]}]
  [:<>
   [:p "You are about to delete the attachment: "
    [:strong filename]]
   [:p.mt-4 "Note that this does not delete the policy document, just unattaches it from this questionnaire."]])

(defn confirm-delete-attachment-modal [{:keys [on-confirm]}]
  (partial confirm-modal
           {:title                 "Confirm Delete Attachment"
            :content               #'modal-content
            :label-confirm         "Confirm Delete"
            :invert-button-colors? true
            :notification-classes  ["has-background-danger" "has-text-white" "is-shadowless"]
            :disable-confirm       false
            :on-confirm            on-confirm}))
